import { forwardRef } from "react"
import {J1 } from "./BlockJElevation.js"

export const BuildingElevationComponent = forwardRef(({ buildingID }, ref) => {
  // console.log(buildingID);

  if (buildingID === "E") {
    return <E1 ref={ref} />
  } else if (buildingID === "K") {
    return <K1 ref={ref} />
  } else if (buildingID === "F") {
    return <F1 ref={ref} />
  }  else if (buildingID === "J") {
    return <J1 ref={ref} />
  }else if (buildingID === "H") {
    return <H1 ref={ref} />
  }    else return null
})

export const H1 = forwardRef((props, ref) => {
  return (
    <svg
    
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      ref={ref}
      height="659.44"
      viewBox="0 0 957.32 659.44"
    >
      <g  

        id="elevation_f1">
        <polyline points="422.05 36.02 422.05 4.39 282.56 4.39 282.56 36.02" fill="none" />
        <rect
          x="147.65"
          y="116.25"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="151.21"
          y="116.25"
          width="109.44"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,107.71s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,114.24l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="566.55 568.41 566.55 276.06 569.51 276.06 569.51 127.76 587.98 126.22 587.98 36.02 466.63 36.02 466.63 568.41 566.55 568.41 566.55 659.05 127.82 659.05 127.82 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <polyline
          points="866.95 568.41 866.95 659.05 566.55 659.05 566.55 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <rect
          x="287.78"
          y="36.02"
          width="178.85"
          height="532.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <polyline
          points="422.05 36.02 422.05 4.39 282.56 4.39 282.56 36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".49"
        />
        <polyline
          points="380.1 4.39 380.1 .25 411.98 .25 411.98 4.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".49"
        />
        <polygon
          points="275.86 36.02 275.86 54.07 127.81 54.07 127.81 568.41 287.78 568.41 287.78 36.02 275.86 36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <polyline
          points="260.09 54.07 260.09 46.25 153.78 46.25 153.78 54.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".49"
        />
        <rect
          x="153.16"
          y="72.41"
          width="41.88"
          height="71.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="84.08"
          x2="195.05"
          y2="84.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="173.93"
          y1="84.08"
          x2="173.93"
          y2="143.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="240.08"
          y="72.41"
          width="19.29"
          height="71.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="240.08"
          y1="84.08"
          x2="259.37"
          y2="84.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="207.63"
          y="72.41"
          width="19.29"
          height="71.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="207.63"
          y1="84.08"
          x2="226.93"
          y2="84.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="147.65"
          y="188.86"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="146.97"
          x2="263.94"
          y2="188.86"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="188.86"
          x2="147.65"
          y2="146.97"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="188.86"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,180.32s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,186.84l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="157.85"
          width="47.92"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="157.85"
          x2="147.5"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="157.85"
          x2="176.93"
          y2="216.09"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="157.85"
          width="38.86"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="157.85"
          x2="201.08"
          y2="146.97"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="146.97"
          x2="220.54"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="157.85"
          x2="259.4"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="157.85"
          x2="239.92"
          y2="216.09"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="261.79"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="219.58"
          x2="263.94"
          y2="261.79"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="261.79"
          x2="147.65"
          y2="219.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="261.79"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,253.25s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,259.77l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="230.29"
          width="47.92"
          height="58.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="230.29"
          x2="147.5"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="230.29"
          x2="176.93"
          y2="289.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="230.29"
          width="38.86"
          height="58.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="230.29"
          x2="201.08"
          y2="219.58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="219.58"
          x2="220.54"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="230.29"
          x2="259.4"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="230.29"
          x2="239.92"
          y2="289.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="333.3"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="292.51"
          x2="263.94"
          y2="333.3"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="333.29"
          x2="147.65"
          y2="292.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="333.3"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,324.75s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,331.28l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="302.85"
          width="47.92"
          height="57.67"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="302.85"
          x2="147.5"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="302.85"
          x2="176.93"
          y2="360.53"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="302.85"
          width="38.86"
          height="57.67"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="302.85"
          x2="201.08"
          y2="292.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="292.51"
          x2="220.54"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="302.85"
          x2="259.4"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="302.85"
          x2="239.92"
          y2="360.53"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="406.22"
          width="116.29"
          height="30.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="364.01"
          x2="263.94"
          y2="406.23"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="406.22"
          x2="147.65"
          y2="364.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="406.22"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,397.68s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,404.21l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="375.46"
          width="47.92"
          height="58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="375.46"
          x2="147.5"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="375.46"
          x2="176.93"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="375.46"
          width="38.86"
          height="58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="375.46"
          x2="201.08"
          y2="364.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="364.01"
          x2="220.54"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="375.46"
          x2="259.4"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="375.46"
          x2="239.92"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="406.22"
          width="74.85"
          height="30.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="406.22"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="375.46"
          width="60.78"
          height="58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="364.58"
          x2="384.58"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="364.58"
          x2="445.36"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="375.46"
          x2="416.43"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="475.85"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="436.38"
          x2="263.94"
          y2="475.28"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="475.29"
          x2="147.65"
          y2="436.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="475.85"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,467.31s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,473.83l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="444.84"
          width="47.92"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="444.83"
          x2="147.5"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="444.83"
          x2="176.93"
          y2="503.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="444.84"
          width="38.86"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="444.83"
          x2="201.08"
          y2="436.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="436.38"
          x2="220.54"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="444.83"
          x2="259.4"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="444.83"
          x2="239.92"
          y2="503.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="263.94"
          y1="506.57"
          x2="263.94"
          y2="549.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="549.74"
          x2="147.65"
          y2="506.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="153.16 549.74 153.16 514.31 201.08 514.31 201.08 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="514.31"
          x2="127.81"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="514.31"
          x2="176.93"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="220.54 549.74 220.54 514.31 259.4 514.31 259.4 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="549.74"
          x2="127.81"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="549.74"
          x2="466.63"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="466.63 549.74 533.44 549.74 533.44 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="533.57 552.28 539.45 552.28 539.45 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="559.01"
          x2="127.81"
          y2="559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="559.01"
          x2="466.63"
          y2="559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="466.63"
          y1="559.01"
          x2="533.44"
          y2="559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="570.83 568.41 570.83 549.73 752.01 549.73 752.01 559.1"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="751.84 552.04 756.94 552.04 756.94 568.28"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="514.31"
          x2="201.08"
          y2="506.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="506.57"
          x2="220.54"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="287.78"
          y1="514.31"
          x2="259.4"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="287.78"
          y1="140.01"
          x2="127.81"
          y2="140.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="283.06"
          y1="139.45"
          x2="283.06"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="392.3"
          y1="375.46"
          x2="392.3"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="375.46"
          x2="440.57"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="375.46"
          width="58.68"
          height="55.05"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="358.39"
          x2="307.23"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="358.39"
          x2="365.91"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="375.46"
          x2="312.28"
          y2="430.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="375.46"
          x2="352.11"
          y2="430.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="379.74"
          y="475.92"
          width="70.36"
          height="33.99"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="382.33"
          y="475.92"
          width="65.19"
          height="30.5"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="444.84"
          width="60.78"
          height="61.58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="436.38"
          x2="384.58"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="436.38"
          x2="445.36"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="444.83"
          x2="440.83"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="444.83"
          x2="416.43"
          y2="506.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="444.83"
          x2="392.3"
          y2="506.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="444.83"
          x2="440.57"
          y2="506.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="716.63"
          y="475.92"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="716.63"
          y="454.09"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="718.65"
          y="475.92"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="736.06 503.44 736.06 444.83 784.69 444.83 784.69 503.44"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="307.23"
          y="444.84"
          width="58.68"
          height="55.36"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="430.51"
          x2="307.23"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="430.51"
          x2="365.91"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="377.49"
          y="334.11"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="334.11"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="302.85"
          width="60.78"
          height="58.49"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="292.46"
          x2="384.58"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="292.46"
          x2="445.36"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="302.85"
          x2="416.43"
          y2="361.34"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="302.85"
          x2="392.3"
          y2="361.34"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="302.85"
          x2="440.57"
          y2="361.34"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="302.85"
          width="58.68"
          height="55.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="285.78"
          x2="307.23"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="285.78"
          x2="365.91"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="302.85"
          x2="312.28"
          y2="358.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="302.85"
          x2="352.11"
          y2="358.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="261.04"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="261.04"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="230.29"
          width="60.78"
          height="57.99"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="219.39"
          x2="384.58"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="219.39"
          x2="445.36"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="230.29"
          x2="416.43"
          y2="288.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="230.29"
          x2="392.3"
          y2="288.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="230.29"
          x2="440.57"
          y2="288.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="230.29"
          width="58.68"
          height="55.04"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="213.2"
          x2="307.23"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="213.2"
          x2="365.91"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="230.29"
          x2="312.28"
          y2="285.32"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="230.29"
          x2="352.11"
          y2="285.32"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="188.92"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="188.92"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="157.85"
          width="60.78"
          height="58.3"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="146.72"
          x2="384.58"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="146.72"
          x2="445.36"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="157.85"
          x2="416.43"
          y2="216.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="157.85"
          x2="392.3"
          y2="216.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="157.85"
          x2="440.57"
          y2="216.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="507.76"
          y="187.23"
          width="58.79"
          height="32.77"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="188.72"
          x2="507.76"
          y2="188.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="157.84"
          width="58.79"
          height="62.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="157.85"
          x2="466.63"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="146.72"
          x2="507.76"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="146.72"
          x2="566.55"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="146.72"
          x2="537.62"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="157.85"
          x2="537.62"
          y2="220"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="157.85"
          width="58.68"
          height="55.36"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="140.29"
          x2="307.23"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="140.29"
          x2="365.91"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="157.85"
          x2="312.28"
          y2="213.21"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="157.85"
          x2="352.11"
          y2="213.21"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="157.85"
          x2="312.28"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="157.85"
          x2="352.11"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="116"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="116"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="54.81"
          width="60.78"
          height="88.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="54.81"
          x2="384.58"
          y2="84.96"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="84.96"
          x2="416.43"
          y2="143.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="54.81"
          x2="392.3"
          y2="143.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="54.81"
          x2="440.57"
          y2="143.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="54.82"
          width="58.68"
          height="85.47"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="54.81"
          x2="307.23"
          y2="36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="54.81"
          x2="312.28"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="54.81"
          x2="352.11"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="365.91"
          y1="444.83"
          x2="360.81"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="444.83"
          x2="312.28"
          y2="500.2"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="444.83"
          x2="352.11"
          y2="500.2"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="384.58 549.74 384.58 514.31 445.36 514.31 445.36 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="509.91"
          x2="384.58"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="509.91"
          x2="445.36"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="514.31"
          x2="416.43"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="514.31"
          x2="392.3"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="514.31"
          x2="440.57"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="583.67 549.74 583.67 513.75 620.1 513.75 620.1 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="307.23 549.74 307.23 514.31 365.91 514.31 365.91 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="500.2"
          x2="307.23"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="500.2"
          x2="365.91"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="514.31"
          x2="312.28"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="514.31"
          x2="352.11"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="271.32"
          y1="514.31"
          x2="271.32"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="276.11"
          y1="514.31"
          x2="276.11"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="331.96"
          y1="514.31"
          x2="331.96"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="85.25"
          x2="352.11"
          y2="85.25"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="85.25"
          x2="440.57"
          y2="85.25"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="203.13"
          x2="507.76"
          y2="203.13"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="211.57"
          x2="566.55"
          y2="211.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="259.47"
          width="58.79"
          height="32.77"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="262.42"
          x2="507.76"
          y2="262.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="230.29"
          width="58.79"
          height="61.95"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="230.29"
          x2="466.63"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="220"
          x2="507.76"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="220"
          x2="566.55"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="220"
          x2="537.62"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="230.29"
          x2="537.62"
          y2="292.23"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="276.83"
          x2="507.76"
          y2="276.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="285.27"
          x2="566.55"
          y2="285.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="332.09"
          width="58.79"
          height="31.64"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="333.92"
          x2="507.76"
          y2="333.92"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="302.85"
          width="58.79"
          height="60.88"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="302.85"
          x2="466.63"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="292.24"
          x2="507.76"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="292.24"
          x2="537.62"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="302.85"
          x2="537.62"
          y2="363.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="348.33"
          x2="507.76"
          y2="348.33"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="356.77"
          x2="566.55"
          y2="356.77"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="403.82"
          width="58.79"
          height="32.57"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="406.77"
          x2="507.76"
          y2="406.77"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="375.46"
          width="58.79"
          height="60.92"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="375.46"
          x2="466.63"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="363.74"
          x2="507.76"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="363.74"
          x2="537.62"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="375.46"
          x2="537.62"
          y2="436.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="421.18"
          x2="507.76"
          y2="421.18"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="429.62"
          x2="566.55"
          y2="429.62"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="474.19"
          width="58.79"
          height="31.64"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="476.02"
          x2="507.76"
          y2="476.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="444.83"
          width="58.79"
          height="61"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="505.83"
          x2="507.76"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="444.83"
          x2="466.63"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="436.38"
          x2="507.76"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="436.38"
          x2="537.62"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="505.83"
          x2="537.62"
          y2="552.28"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="444.83"
          x2="537.62"
          y2="505.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="490.42"
          x2="507.76"
          y2="490.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="498.87"
          x2="566.55"
          y2="498.87"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="114.91"
          width="58.79"
          height="31.81"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="116.4"
          x2="507.76"
          y2="116.4"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="86.69"
          width="58.79"
          height="60.04"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="86.68"
          x2="466.63"
          y2="86.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="36.02"
          x2="507.76"
          y2="86.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="36.02"
          x2="566.55"
          y2="86.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="86.68"
          x2="537.62"
          y2="146.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="537.62"
          y1="86.68"
          x2="537.62"
          y2="36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="130.81"
          x2="507.76"
          y2="130.81"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="139.25"
          x2="566.55"
          y2="139.25"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="54.89"
          x2="466.63"
          y2="54.89"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="514.31"
          x2="566.55"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="514.31"
          x2="445.36"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="384.58"
          y1="514.31"
          x2="365.91"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="307.23"
          y1="514.31"
          x2="287.78"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="573.28 568.17 573.28 559.01 755.38 559.01 755.38 568.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="686.22"
          y1="559.01"
          x2="686.22"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="674.37"
          y1="559.01"
          x2="674.37"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="632.39"
          y1="559.01"
          x2="632.39"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="624.62"
          y1="559.01"
          x2="624.62"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="784.11 559.01 784.11 549.74 866.95 549.74 866.95 565.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="780.91 568.17 780.91 559.01 866.95 559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="855.03"
          y1="559.01"
          x2="855.03"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="866.67"
          y1="559.01"
          x2="866.67"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="863.85"
          y1="559.01"
          x2="863.85"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="605.83"
          y1="513.93"
          x2="605.83"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="648.75"
          y1="513.75"
          x2="648.75"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="675.85 549.74 675.85 513.75 712.28 513.75 712.28 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="698.01"
          y1="513.75"
          x2="698.01"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="629.54 549.74 629.54 513.75 666.53 513.75 666.53 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="774.65 568.54 774.65 513.75 811.08 513.75 811.08 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="796.81"
          y1="513.75"
          x2="796.81"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="728.34 549.74 728.34 513.75 765.33 513.75 765.33 568.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="820.65 549.74 820.65 513.75 857.65 513.75 857.65 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="760.25"
          y1="444.83"
          x2="760.25"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="718.65"
          y1="498.8"
          x2="788.53"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="475.92"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="454.09"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="573.28"
          y="475.92"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="590.69 503.44 590.69 444.83 639.31 444.83 639.31 503.44"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="614.88"
          y1="444.83"
          x2="614.88"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="573.28"
          y1="498.8"
          x2="643.15"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="808.86"
          y="444.84"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="663.22"
          y="444.84"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="716.63"
          y="406.58"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="716.63"
          y="384.76"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="718.65"
          y="406.58"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="736.06 434.11 736.06 375.5 784.69 375.5 784.69 434.11"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="760.25"
          y1="375.5"
          x2="760.25"
          y2="429.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="718.65"
          y1="429.46"
          x2="788.53"
          y2="429.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="406.58"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="384.76"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="573.28"
          y="406.58"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="590.69 434.11 590.69 375.5 639.31 375.5 639.31 434.11"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="614.88"
          y1="375.46"
          x2="614.88"
          y2="429.47"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="573.28"
          y1="429.46"
          x2="643.15"
          y2="429.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="808.86"
          y="375.5"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="663.22"
          y="375.5"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="731.2"
          y="294.42"
          width="60.94"
          height="55.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="731.2"
          y1="294.42"
          x2="731.2"
          y2="276.4"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="731.2"
          y="333.5"
          width="60.94"
          height="13.93"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="737.19 349.69 737.19 302.42 781.38 302.42 781.38 349.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="789.19 349.69 789.19 302.42 791.98 302.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="787.2 349.69 787.2 319.46 789.13 319.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="760.25"
          y1="302.42"
          x2="760.25"
          y2="349.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="663.22"
          y="302.42"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="590.93"
          y="302.42"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="737.04"
          y="260.69"
          width="44.19"
          height="15.38"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="737.04 276.06 737.04 210.35 781.23 210.35 781.23 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="737.04"
          y1="230.35"
          x2="781.23"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="760.11"
          y1="230.35"
          x2="760.11"
          y2="276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="789.04"
          y="260.69"
          width="24.32"
          height="15.38"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="789.04 276.06 789.04 210.35 813.36 210.35 813.36 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="789.04"
          y1="230.35"
          x2="813.36"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="825.69"
          y="260.69"
          width="24.32"
          height="15.38"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="825.69 276.06 825.69 210.35 850.01 210.35 850.01 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="825.69"
          y1="230.35"
          x2="850.01"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="801.32"
          y="294.42"
          width="60.94"
          height="55.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="801.32"
          y="333.5"
          width="60.94"
          height="13.93"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="850.32 349.69 850.32 302.42 825.46 302.42 825.46 349.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="813.01 349.69 813.01 302.42 801.49 302.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="569.51"
          y1="276.06"
          x2="866.95"
          y2="276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="575.21"
          y="262.01"
          width="147.26"
          height="14.05"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="707.44 276.06 707.44 146.24 663.25 146.24 663.25 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="707.44"
          y1="230.35"
          x2="663.25"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="684.37"
          y1="230.29"
          x2="684.37"
          y2="276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="646.08 276.06 646.08 146.24 627.3 146.24 627.3 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="646.08"
          y1="230.35"
          x2="627.3"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="613.29 276.06 613.29 146.24 590.87 146.24 590.87 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="613.29"
          y1="230.35"
          x2="590.87"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="574.08 276.07 574.08 260.69 723.59 260.69 723.59 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="590.87"
          y="189.16"
          width="22.42"
          height="23.65"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="627.3"
          y="189.16"
          width="18.78"
          height="23.65"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="663.25"
          y="189.16"
          width="44.19"
          height="23.65"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="707.44"
          y1="158.16"
          x2="663.25"
          y2="158.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="684.37"
          y1="158.16"
          x2="684.37"
          y2="212.81"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="646.08"
          y1="158.16"
          x2="627.3"
          y2="158.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="613.29"
          y1="158.16"
          x2="590.87"
          y2="158.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polygon
          points="866.95 175.11 737.02 163.73 737.02 110.75 587.98 126.22 569.51 127.76 569.51 276.07 566.55 276.07 566.55 568.41 866.95 568.41 866.95 175.11"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <line
          x1="127.81"
          y1="613.73"
          x2="566.55"
          y2="613.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="866.95"
          y1="613.73"
          x2="566.55"
          y2="613.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="839.73"
          y1="513.75"
          x2="839.73"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="747.48"
          y1="513.75"
          x2="747.48"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="544.91"
          x2="352.11"
          y2="544.91"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="239.74"
          y1="514.31"
          x2="239.74"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="220.54"
          y1="544.91"
          x2="259.4"
          y2="544.91"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="616.11"
          y1="302.42"
          x2="616.11"
          y2="349.1"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="590.93"
          y1="333.45"
          x2="639.55"
          y2="333.45"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="688.41"
          y1="302.42"
          x2="688.41"
          y2="349.1"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="663.22"
          y1="333.45"
          x2="711.84"
          y2="333.45"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="688.41"
          y1="375.5"
          x2="688.41"
          y2="422.19"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="663.22"
          y1="406.54"
          x2="711.84"
          y2="406.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="833.98"
          y1="375.5"
          x2="833.98"
          y2="422.19"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="808.8"
          y1="406.54"
          x2="857.42"
          y2="406.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="834.05"
          y1="444.83"
          x2="834.05"
          y2="491.52"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="808.86"
          y1="475.87"
          x2="857.48"
          y2="475.87"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="688.41"
          y1="444.83"
          x2="688.41"
          y2="491.52"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="663.22"
          y1="475.87"
          x2="711.84"
          y2="475.87"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="444.83"
          x2="332.16"
          y2="500.2"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="476.44"
          x2="352.11"
          y2="476.44"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="490.69"
          x2="352.11"
          y2="490.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="375.28"
          x2="332.16"
          y2="430.64"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="406.88"
          x2="352.11"
          y2="406.88"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="421.13"
          x2="352.11"
          y2="421.13"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="302.94"
          x2="332.16"
          y2="358.3"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="334.54"
          x2="352.11"
          y2="334.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="348.79"
          x2="352.11"
          y2="348.79"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.11"
          y1="230.12"
          x2="332.11"
          y2="285.49"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.24"
          y1="261.73"
          x2="352.07"
          y2="261.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.24"
          y1="275.97"
          x2="352.07"
          y2="275.97"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.07"
          y1="157.84"
          x2="332.07"
          y2="213.21"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.2"
          y1="189.45"
          x2="352.03"
          y2="189.45"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.2"
          y1="203.7"
          x2="352.03"
          y2="203.7"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="85.25"
          x2="332.16"
          y2="140.13"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="116.37"
          x2="352.11"
          y2="116.37"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="130.61"
          x2="352.11"
          y2="130.61"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
      </g>
      <g id="Layer_3" data-name="Layer 3" />
      <g id="interactive_floors">
        <rect id="floor_circle_1" y="594.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_1"
          transform="translate(17.29 634.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            0
          </tspan>
        </text>
        <rect id="floor_circle_2" y="529.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_2"
          transform="translate(13.79 569.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            1
          </tspan>
        </text>
        <rect id="floor_circle_3" y="460.56" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_3"
          transform="translate(15.05 500.19)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            2
          </tspan>
        </text>
        <rect id="floor_circle_4" y="390.61" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_4"
          transform="translate(14.49 430.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="floor_circle_5" y="319.62" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_5"
          transform="translate(14.64 359.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            4
          </tspan>
        </text>
        <rect id="floor_circle_6" y="247.58" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_6"
          transform="translate(13.72 287.22)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            5
          </tspan>
        </text>
        <rect id="floor_circle_7" y="175.55" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_7"
          transform="translate(15.16 215.18)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            6
          </tspan>
        </text>
        <rect id="floor_circle_8" y="103.51" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_8"
          transform="translate(14.1 143.15)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            7
          </tspan>
        </text>
        <rect id="apt_circle_1" x="906" y="593.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_1"
          transform="translate(921.05 633.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            8
          </tspan>
        </text>
        <rect id="apt_circle_2" x="906" y="528.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_2"
          transform="translate(921.05 568.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            9
          </tspan>
        </text>
        <rect id="apt_circle_3" x="906" y="459.56" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_3"
          transform="translate(921.05 499.19)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            10
          </tspan>
        </text>
        <rect id="apt_circle_4" x="906" y="389.61" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_4"
          transform="translate(921.05 429.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_5" x="906" y="318.62" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_5"
          transform="translate(921.05 358.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect
          id="apt_circle_5-2"
          data-name="apt_circle_5"
          x="906"
          y="246.58"
          width="49.74"
          height="47.58"
          fill="#75938f"
        />
        <text
          id="apt_no_6"
          transform="translate(921.05 286.22)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_6" x="906" y="174.55" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_7"
          transform="translate(921.05 214.18)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_8" x="906" y="102.51" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_8"
          transform="translate(921.05 142.15)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect
          id="floor_button_0"
          x="128.32"
          y="578.95"
          width="737.99"
          height="79.91"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_1"
          x="128.32"
          y="506.04"
          width="738"
          height="73.1"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_2"
          x="128.32"
          y="435.6"
          width="738"
          height="70.44"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_3"
          x="128.32"
          y="362.54"
          width="738"
          height="73.05"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_4"
          x="128.32"
          y="290.78"
          width="737.99"
          height="71.77"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_5"
          x="128.32"
          y="219.01"
          width="737.99"
          height="71.77"
          fill="#7aa9a5"
          opacity=".5"
        />
        <polyline
          id="floor_button_6"
          points="127.32 149.86 569.32 149.86 570.42 128.04 737.02 110.75 737.02 163.73 866.95 175.11 866.95 219.07 128.32 220 127.32 149.86"
          fill="#7aa9a5"
          opacity=".5"
        />
        <path
          id="floor_button_7"
          d="M588.32,34.86h-164l-142,1h-7v18h-15v-.33c-.13,0-.25,.02-.38,.02h-106.62v.31c-8.33,.07-16.67,.14-25,.21-.33,31.93-.67,63.86-1,95.79h442c.37-7.27,.73-14.55,1.1-21.82l18.41-1.82-.51-91.36Z"
          fill="#7aa9a5"
          opacity=".5"
        />
      </g>
    </svg>
  )
})
export const F1 = forwardRef((props, ref) => {
  return (
    <svg
    
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      ref={ref}
      height="659.44"
      viewBox="0 0 957.32 659.44"
    >
      <g  

        id="elevation_f1">
        <polyline points="422.05 36.02 422.05 4.39 282.56 4.39 282.56 36.02" fill="none" />
        <rect
          x="147.65"
          y="116.25"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="151.21"
          y="116.25"
          width="109.44"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,107.71s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,114.24l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="566.55 568.41 566.55 276.06 569.51 276.06 569.51 127.76 587.98 126.22 587.98 36.02 466.63 36.02 466.63 568.41 566.55 568.41 566.55 659.05 127.82 659.05 127.82 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <polyline
          points="866.95 568.41 866.95 659.05 566.55 659.05 566.55 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <rect
          x="287.78"
          y="36.02"
          width="178.85"
          height="532.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <polyline
          points="422.05 36.02 422.05 4.39 282.56 4.39 282.56 36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".49"
        />
        <polyline
          points="380.1 4.39 380.1 .25 411.98 .25 411.98 4.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".49"
        />
        <polygon
          points="275.86 36.02 275.86 54.07 127.81 54.07 127.81 568.41 287.78 568.41 287.78 36.02 275.86 36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <polyline
          points="260.09 54.07 260.09 46.25 153.78 46.25 153.78 54.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".49"
        />
        <rect
          x="153.16"
          y="72.41"
          width="41.88"
          height="71.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="84.08"
          x2="195.05"
          y2="84.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="173.93"
          y1="84.08"
          x2="173.93"
          y2="143.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="240.08"
          y="72.41"
          width="19.29"
          height="71.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="240.08"
          y1="84.08"
          x2="259.37"
          y2="84.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="207.63"
          y="72.41"
          width="19.29"
          height="71.07"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="207.63"
          y1="84.08"
          x2="226.93"
          y2="84.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="147.65"
          y="188.86"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="146.97"
          x2="263.94"
          y2="188.86"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="188.86"
          x2="147.65"
          y2="146.97"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="188.86"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,180.32s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,186.84l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="157.85"
          width="47.92"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="157.85"
          x2="147.5"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="157.85"
          x2="176.93"
          y2="216.09"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="157.85"
          width="38.86"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="157.85"
          x2="201.08"
          y2="146.97"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="146.97"
          x2="220.54"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="157.85"
          x2="259.4"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="157.85"
          x2="239.92"
          y2="216.09"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="261.79"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="219.58"
          x2="263.94"
          y2="261.79"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="261.79"
          x2="147.65"
          y2="219.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="261.79"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,253.25s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,259.77l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="230.29"
          width="47.92"
          height="58.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="230.29"
          x2="147.5"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="230.29"
          x2="176.93"
          y2="289.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="230.29"
          width="38.86"
          height="58.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="230.29"
          x2="201.08"
          y2="219.58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="219.58"
          x2="220.54"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="230.29"
          x2="259.4"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="230.29"
          x2="239.92"
          y2="289.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="333.3"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="292.51"
          x2="263.94"
          y2="333.3"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="333.29"
          x2="147.65"
          y2="292.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="333.3"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,324.75s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,331.28l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="302.85"
          width="47.92"
          height="57.67"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="302.85"
          x2="147.5"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="302.85"
          x2="176.93"
          y2="360.53"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="302.85"
          width="38.86"
          height="57.67"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="302.85"
          x2="201.08"
          y2="292.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="292.51"
          x2="220.54"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="302.85"
          x2="259.4"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="302.85"
          x2="239.92"
          y2="360.53"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="406.22"
          width="116.29"
          height="30.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="364.01"
          x2="263.94"
          y2="406.23"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="406.22"
          x2="147.65"
          y2="364.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="406.22"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,397.68s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,404.21l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="375.46"
          width="47.92"
          height="58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="375.46"
          x2="147.5"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="375.46"
          x2="176.93"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="375.46"
          width="38.86"
          height="58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="375.46"
          x2="201.08"
          y2="364.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="364.01"
          x2="220.54"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="375.46"
          x2="259.4"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="375.46"
          x2="239.92"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="406.22"
          width="74.85"
          height="30.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="406.22"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="375.46"
          width="60.78"
          height="58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="364.58"
          x2="384.58"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="364.58"
          x2="445.36"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="375.46"
          x2="416.43"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="147.65"
          y="475.85"
          width="116.29"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="263.94"
          y1="436.38"
          x2="263.94"
          y2="475.28"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="475.29"
          x2="147.65"
          y2="436.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="150.08"
          y="475.85"
          width="111.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,467.31s-8.9-.03-25.21-.03-22.72,1.04-22.72,1.04v37.75h47.94v-38.76Z"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <path
          d="M127.81,473.83l-9.66-.03s-28.12-5.48-38.28-5.48"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="153.16"
          y="444.84"
          width="47.92"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="444.83"
          x2="147.5"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="444.83"
          x2="176.93"
          y2="503.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="220.54"
          y="444.84"
          width="38.86"
          height="58.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="444.83"
          x2="201.08"
          y2="436.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="436.38"
          x2="220.54"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="264.34"
          y1="444.83"
          x2="259.4"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="239.92"
          y1="444.83"
          x2="239.92"
          y2="503.08"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="263.94"
          y1="506.57"
          x2="263.94"
          y2="549.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="147.65"
          y1="549.74"
          x2="147.65"
          y2="506.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="153.16 549.74 153.16 514.31 201.08 514.31 201.08 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="153.16"
          y1="514.31"
          x2="127.81"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="176.93"
          y1="514.31"
          x2="176.93"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="220.54 549.74 220.54 514.31 259.4 514.31 259.4 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="549.74"
          x2="127.81"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="549.74"
          x2="466.63"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="466.63 549.74 533.44 549.74 533.44 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="533.57 552.28 539.45 552.28 539.45 568.41"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="559.01"
          x2="127.81"
          y2="559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="287.78"
          y1="559.01"
          x2="466.63"
          y2="559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="466.63"
          y1="559.01"
          x2="533.44"
          y2="559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="570.83 568.41 570.83 549.73 752.01 549.73 752.01 559.1"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="751.84 552.04 756.94 552.04 756.94 568.28"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="201.08"
          y1="514.31"
          x2="201.08"
          y2="506.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="220.54"
          y1="506.57"
          x2="220.54"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="287.78"
          y1="514.31"
          x2="259.4"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="287.78"
          y1="140.01"
          x2="127.81"
          y2="140.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="283.06"
          y1="139.45"
          x2="283.06"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="392.3"
          y1="375.46"
          x2="392.3"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="375.46"
          x2="440.57"
          y2="433.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="375.46"
          width="58.68"
          height="55.05"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="358.39"
          x2="307.23"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="358.39"
          x2="365.91"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="375.46"
          x2="312.28"
          y2="430.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="375.46"
          x2="352.11"
          y2="430.51"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="379.74"
          y="475.92"
          width="70.36"
          height="33.99"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="382.33"
          y="475.92"
          width="65.19"
          height="30.5"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="444.84"
          width="60.78"
          height="61.58"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="436.38"
          x2="384.58"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="436.38"
          x2="445.36"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="444.83"
          x2="440.83"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="444.83"
          x2="416.43"
          y2="506.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="444.83"
          x2="392.3"
          y2="506.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="444.83"
          x2="440.57"
          y2="506.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="716.63"
          y="475.92"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="716.63"
          y="454.09"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="718.65"
          y="475.92"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="736.06 503.44 736.06 444.83 784.69 444.83 784.69 503.44"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="307.23"
          y="444.84"
          width="58.68"
          height="55.36"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="430.51"
          x2="307.23"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="430.51"
          x2="365.91"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="377.49"
          y="334.11"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="334.11"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="302.85"
          width="60.78"
          height="58.49"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="292.46"
          x2="384.58"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="292.46"
          x2="445.36"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="302.85"
          x2="416.43"
          y2="361.34"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="302.85"
          x2="392.3"
          y2="361.34"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="302.85"
          x2="440.57"
          y2="361.34"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="302.85"
          width="58.68"
          height="55.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="285.78"
          x2="307.23"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="285.78"
          x2="365.91"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="302.85"
          x2="312.28"
          y2="358.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="302.85"
          x2="352.11"
          y2="358.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="261.04"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="261.04"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="230.29"
          width="60.78"
          height="57.99"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="219.39"
          x2="384.58"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="219.39"
          x2="445.36"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="230.29"
          x2="416.43"
          y2="288.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="230.29"
          x2="392.3"
          y2="288.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="230.29"
          x2="440.57"
          y2="288.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="230.29"
          width="58.68"
          height="55.04"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="213.2"
          x2="307.23"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="213.2"
          x2="365.91"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="230.29"
          x2="312.28"
          y2="285.32"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="230.29"
          x2="352.11"
          y2="285.32"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="188.92"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="188.92"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="157.85"
          width="60.78"
          height="58.3"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="146.72"
          x2="384.58"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="146.72"
          x2="445.36"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="157.85"
          x2="416.43"
          y2="216.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="157.85"
          x2="392.3"
          y2="216.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="157.85"
          x2="440.57"
          y2="216.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="507.76"
          y="187.23"
          width="58.79"
          height="32.77"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="188.72"
          x2="507.76"
          y2="188.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="157.84"
          width="58.79"
          height="62.15"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="157.85"
          x2="466.63"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="146.72"
          x2="507.76"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="146.72"
          x2="566.55"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="146.72"
          x2="537.62"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="157.85"
          x2="537.62"
          y2="220"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="157.85"
          width="58.68"
          height="55.36"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="140.29"
          x2="307.23"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="140.29"
          x2="365.91"
          y2="157.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="157.85"
          x2="312.28"
          y2="213.21"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="157.85"
          x2="352.11"
          y2="213.21"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="157.85"
          x2="312.28"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="157.85"
          x2="352.11"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="377.49"
          y="116"
          width="74.85"
          height="30.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="380.07"
          y="116"
          width="69.69"
          height="27.23"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="384.58"
          y="54.81"
          width="60.78"
          height="88.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="54.81"
          x2="384.58"
          y2="84.96"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="84.96"
          x2="416.43"
          y2="143.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="54.81"
          x2="392.3"
          y2="143.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="54.81"
          x2="440.57"
          y2="143.24"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="307.23"
          y="54.82"
          width="58.68"
          height="85.47"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="54.81"
          x2="307.23"
          y2="36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="54.81"
          x2="312.28"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="54.81"
          x2="352.11"
          y2="140.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="365.91"
          y1="444.83"
          x2="360.81"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="444.83"
          x2="312.28"
          y2="500.2"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="444.83"
          x2="352.11"
          y2="500.2"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="384.58 549.74 384.58 514.31 445.36 514.31 445.36 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="384.58"
          y1="509.91"
          x2="384.58"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="445.36"
          y1="509.91"
          x2="445.36"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="416.43"
          y1="514.31"
          x2="416.43"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="514.31"
          x2="392.3"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="440.57"
          y1="514.31"
          x2="440.57"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="583.67 549.74 583.67 513.75 620.1 513.75 620.1 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="307.23 549.74 307.23 514.31 365.91 514.31 365.91 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="307.23"
          y1="500.2"
          x2="307.23"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="365.91"
          y1="500.2"
          x2="365.91"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="312.28"
          y1="514.31"
          x2="312.28"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="352.11"
          y1="514.31"
          x2="352.11"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="271.32"
          y1="514.31"
          x2="271.32"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="276.11"
          y1="514.31"
          x2="276.11"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="331.96"
          y1="514.31"
          x2="331.96"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="85.25"
          x2="352.11"
          y2="85.25"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="392.3"
          y1="85.25"
          x2="440.57"
          y2="85.25"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="203.13"
          x2="507.76"
          y2="203.13"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="211.57"
          x2="566.55"
          y2="211.57"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="259.47"
          width="58.79"
          height="32.77"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="262.42"
          x2="507.76"
          y2="262.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="230.29"
          width="58.79"
          height="61.95"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="230.29"
          x2="466.63"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="220"
          x2="507.76"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="220"
          x2="566.55"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="220"
          x2="537.62"
          y2="230.29"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="230.29"
          x2="537.62"
          y2="292.23"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="276.83"
          x2="507.76"
          y2="276.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="285.27"
          x2="566.55"
          y2="285.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="332.09"
          width="58.79"
          height="31.64"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="333.92"
          x2="507.76"
          y2="333.92"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="302.85"
          width="58.79"
          height="60.88"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="302.85"
          x2="466.63"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="292.24"
          x2="507.76"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="292.24"
          x2="537.62"
          y2="302.85"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="302.85"
          x2="537.62"
          y2="363.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="348.33"
          x2="507.76"
          y2="348.33"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="356.77"
          x2="566.55"
          y2="356.77"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="403.82"
          width="58.79"
          height="32.57"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="406.77"
          x2="507.76"
          y2="406.77"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="375.46"
          width="58.79"
          height="60.92"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="375.46"
          x2="466.63"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="363.74"
          x2="507.76"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="363.74"
          x2="537.62"
          y2="375.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="375.46"
          x2="537.62"
          y2="436.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="421.18"
          x2="507.76"
          y2="421.18"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="429.62"
          x2="566.55"
          y2="429.62"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="474.19"
          width="58.79"
          height="31.64"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="476.02"
          x2="507.76"
          y2="476.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="444.83"
          width="58.79"
          height="61"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="505.83"
          x2="507.76"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="444.83"
          x2="466.63"
          y2="444.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="436.38"
          x2="507.76"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="436.38"
          x2="537.62"
          y2="444.84"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="505.83"
          x2="537.62"
          y2="552.28"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="444.83"
          x2="537.62"
          y2="505.83"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="466.63"
          y1="490.42"
          x2="507.76"
          y2="490.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="498.87"
          x2="566.55"
          y2="498.87"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="114.91"
          width="58.79"
          height="31.81"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="116.4"
          x2="507.76"
          y2="116.4"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="507.76"
          y="86.69"
          width="58.79"
          height="60.04"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="507.76"
          y1="86.68"
          x2="466.63"
          y2="86.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="507.76"
          y1="36.02"
          x2="507.76"
          y2="86.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="36.02"
          x2="566.55"
          y2="86.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="537.62"
          y1="86.68"
          x2="537.62"
          y2="146.72"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="537.62"
          y1="86.68"
          x2="537.62"
          y2="36.02"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="130.81"
          x2="507.76"
          y2="130.81"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="139.25"
          x2="566.55"
          y2="139.25"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="566.55"
          y1="54.89"
          x2="466.63"
          y2="54.89"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="514.31"
          x2="566.55"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="466.63"
          y1="514.31"
          x2="445.36"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="384.58"
          y1="514.31"
          x2="365.91"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="307.23"
          y1="514.31"
          x2="287.78"
          y2="514.31"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="573.28 568.17 573.28 559.01 755.38 559.01 755.38 568.38"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="686.22"
          y1="559.01"
          x2="686.22"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="674.37"
          y1="559.01"
          x2="674.37"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="632.39"
          y1="559.01"
          x2="632.39"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="624.62"
          y1="559.01"
          x2="624.62"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="784.11 559.01 784.11 549.74 866.95 549.74 866.95 565.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="780.91 568.17 780.91 559.01 866.95 559.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="855.03"
          y1="559.01"
          x2="855.03"
          y2="568.39"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="866.67"
          y1="559.01"
          x2="866.67"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="863.85"
          y1="559.01"
          x2="863.85"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="605.83"
          y1="513.93"
          x2="605.83"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="648.75"
          y1="513.75"
          x2="648.75"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="675.85 549.74 675.85 513.75 712.28 513.75 712.28 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="698.01"
          y1="513.75"
          x2="698.01"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="629.54 549.74 629.54 513.75 666.53 513.75 666.53 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="774.65 568.54 774.65 513.75 811.08 513.75 811.08 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="796.81"
          y1="513.75"
          x2="796.81"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="728.34 549.74 728.34 513.75 765.33 513.75 765.33 568.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="820.65 549.74 820.65 513.75 857.65 513.75 857.65 549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="760.25"
          y1="444.83"
          x2="760.25"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="718.65"
          y1="498.8"
          x2="788.53"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="475.92"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="454.09"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="573.28"
          y="475.92"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="590.69 503.44 590.69 444.83 639.31 444.83 639.31 503.44"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="614.88"
          y1="444.83"
          x2="614.88"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="573.28"
          y1="498.8"
          x2="643.15"
          y2="498.8"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="808.86"
          y="444.84"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="663.22"
          y="444.84"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="716.63"
          y="406.58"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="716.63"
          y="384.76"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="718.65"
          y="406.58"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="736.06 434.11 736.06 375.5 784.69 375.5 784.69 434.11"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="760.25"
          y1="375.5"
          x2="760.25"
          y2="429.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="718.65"
          y1="429.46"
          x2="788.53"
          y2="429.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="406.58"
          width="74.48"
          height="31.01"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="571.26"
          y="384.76"
          width="1.98"
          height="21.82"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="573.28"
          y="406.58"
          width="69.87"
          height="27.53"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="590.69 434.11 590.69 375.5 639.31 375.5 639.31 434.11"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="614.88"
          y1="375.46"
          x2="614.88"
          y2="429.47"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="573.28"
          y1="429.46"
          x2="643.15"
          y2="429.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="808.86"
          y="375.5"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="663.22"
          y="375.5"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="731.2"
          y="294.42"
          width="60.94"
          height="55.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="731.2"
          y1="294.42"
          x2="731.2"
          y2="276.4"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="731.2"
          y="333.5"
          width="60.94"
          height="13.93"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="737.19 349.69 737.19 302.42 781.38 302.42 781.38 349.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="789.19 349.69 789.19 302.42 791.98 302.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="787.2 349.69 787.2 319.46 789.13 319.46"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="760.25"
          y1="302.42"
          x2="760.25"
          y2="349.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="663.22"
          y="302.42"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="590.93"
          y="302.42"
          width="48.62"
          height="46.68"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="737.04"
          y="260.69"
          width="44.19"
          height="15.38"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="737.04 276.06 737.04 210.35 781.23 210.35 781.23 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="737.04"
          y1="230.35"
          x2="781.23"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="760.11"
          y1="230.35"
          x2="760.11"
          y2="276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="789.04"
          y="260.69"
          width="24.32"
          height="15.38"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="789.04 276.06 789.04 210.35 813.36 210.35 813.36 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="789.04"
          y1="230.35"
          x2="813.36"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="825.69"
          y="260.69"
          width="24.32"
          height="15.38"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="825.69 276.06 825.69 210.35 850.01 210.35 850.01 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="825.69"
          y1="230.35"
          x2="850.01"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <rect
          x="801.32"
          y="294.42"
          width="60.94"
          height="55.27"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="801.32"
          y="333.5"
          width="60.94"
          height="13.93"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="850.32 349.69 850.32 302.42 825.46 302.42 825.46 349.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <polyline
          points="813.01 349.69 813.01 302.42 801.49 302.42"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="569.51"
          y1="276.06"
          x2="866.95"
          y2="276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <rect
          x="575.21"
          y="262.01"
          width="147.26"
          height="14.05"
          fill="none"
          stroke="#1d1d1b"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <polyline
          points="707.44 276.06 707.44 146.24 663.25 146.24 663.25 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="707.44"
          y1="230.35"
          x2="663.25"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="684.37"
          y1="230.29"
          x2="684.37"
          y2="276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="646.08 276.06 646.08 146.24 627.3 146.24 627.3 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="646.08"
          y1="230.35"
          x2="627.3"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="613.29 276.06 613.29 146.24 590.87 146.24 590.87 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="613.29"
          y1="230.35"
          x2="590.87"
          y2="230.35"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polyline
          points="574.08 276.07 574.08 260.69 723.59 260.69 723.59 276.06"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="590.87"
          y="189.16"
          width="22.42"
          height="23.65"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="627.3"
          y="189.16"
          width="18.78"
          height="23.65"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <rect
          x="663.25"
          y="189.16"
          width="44.19"
          height="23.65"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".19"
        />
        <line
          x1="707.44"
          y1="158.16"
          x2="663.25"
          y2="158.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="684.37"
          y1="158.16"
          x2="684.37"
          y2="212.81"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="646.08"
          y1="158.16"
          x2="627.3"
          y2="158.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="613.29"
          y1="158.16"
          x2="590.87"
          y2="158.16"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <polygon
          points="866.95 175.11 737.02 163.73 737.02 110.75 587.98 126.22 569.51 127.76 569.51 276.07 566.55 276.07 566.55 568.41 866.95 568.41 866.95 175.11"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".78"
        />
        <line
          x1="127.81"
          y1="613.73"
          x2="566.55"
          y2="613.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="866.95"
          y1="613.73"
          x2="566.55"
          y2="613.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".29"
        />
        <line
          x1="839.73"
          y1="513.75"
          x2="839.73"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="747.48"
          y1="513.75"
          x2="747.48"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="544.91"
          x2="352.11"
          y2="544.91"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="239.74"
          y1="514.31"
          x2="239.74"
          y2="549.74"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="220.54"
          y1="544.91"
          x2="259.4"
          y2="544.91"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="616.11"
          y1="302.42"
          x2="616.11"
          y2="349.1"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="590.93"
          y1="333.45"
          x2="639.55"
          y2="333.45"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="688.41"
          y1="302.42"
          x2="688.41"
          y2="349.1"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="663.22"
          y1="333.45"
          x2="711.84"
          y2="333.45"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="688.41"
          y1="375.5"
          x2="688.41"
          y2="422.19"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="663.22"
          y1="406.54"
          x2="711.84"
          y2="406.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="833.98"
          y1="375.5"
          x2="833.98"
          y2="422.19"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="808.8"
          y1="406.54"
          x2="857.42"
          y2="406.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="834.05"
          y1="444.83"
          x2="834.05"
          y2="491.52"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="808.86"
          y1="475.87"
          x2="857.48"
          y2="475.87"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="688.41"
          y1="444.83"
          x2="688.41"
          y2="491.52"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="663.22"
          y1="475.87"
          x2="711.84"
          y2="475.87"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="444.83"
          x2="332.16"
          y2="500.2"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="476.44"
          x2="352.11"
          y2="476.44"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="490.69"
          x2="352.11"
          y2="490.69"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="375.28"
          x2="332.16"
          y2="430.64"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="406.88"
          x2="352.11"
          y2="406.88"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="421.13"
          x2="352.11"
          y2="421.13"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="302.94"
          x2="332.16"
          y2="358.3"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="334.54"
          x2="352.11"
          y2="334.54"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="348.79"
          x2="352.11"
          y2="348.79"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.11"
          y1="230.12"
          x2="332.11"
          y2="285.49"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.24"
          y1="261.73"
          x2="352.07"
          y2="261.73"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.24"
          y1="275.97"
          x2="352.07"
          y2="275.97"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.07"
          y1="157.84"
          x2="332.07"
          y2="213.21"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.2"
          y1="189.45"
          x2="352.03"
          y2="189.45"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.2"
          y1="203.7"
          x2="352.03"
          y2="203.7"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="332.16"
          y1="85.25"
          x2="332.16"
          y2="140.13"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="116.37"
          x2="352.11"
          y2="116.37"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
        <line
          x1="312.28"
          y1="130.61"
          x2="352.11"
          y2="130.61"
          fill="none"
          stroke="#2b2523"
          strokeMiterlimit="10"
          strokeWidth=".13"
        />
      </g>
      <g id="Layer_3" data-name="Layer 3" />
      <g id="interactive_floors">
        <rect id="floor_circle_1" y="594.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_1"
          transform="translate(17.29 634.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            1
          </tspan>
        </text>
        <rect id="floor_circle_2" y="529.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_2"
          transform="translate(13.79 569.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            2
          </tspan>
        </text>
        <rect id="floor_circle_3" y="460.56" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_3"
          transform="translate(15.05 500.19)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="floor_circle_4" y="390.61" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_4"
          transform="translate(14.49 430.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            4
          </tspan>
        </text>
        <rect id="floor_circle_5" y="319.62" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_5"
          transform="translate(14.64 359.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            5
          </tspan>
        </text>
        <rect id="floor_circle_6" y="247.58" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_6"
          transform="translate(13.72 287.22)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            6
          </tspan>
        </text>
        <rect id="floor_circle_7" y="175.55" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_7"
          transform="translate(15.16 215.18)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            7
          </tspan>
        </text>
        <rect id="floor_circle_8" y="103.51" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="floor_no_8"
          transform="translate(14.1 143.15)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            8
          </tspan>
        </text>
        <rect id="apt_circle_1" x="906" y="593.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_1"
          transform="translate(921.05 633.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_2" x="906" y="528.46" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_2"
          transform="translate(921.05 568.1)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_3" x="906" y="459.56" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_3"
          transform="translate(921.05 499.19)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_4" x="906" y="389.61" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_4"
          transform="translate(921.05 429.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_5" x="906" y="318.62" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_5"
          transform="translate(921.05 358.25)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect
          id="apt_circle_5-2"
          data-name="apt_circle_5"
          x="906"
          y="246.58"
          width="49.74"
          height="47.58"
          fill="#75938f"
        />
        <text
          id="apt_no_6"
          transform="translate(921.05 286.22)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_6" x="906" y="174.55" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_7"
          transform="translate(921.05 214.18)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect id="apt_circle_8" x="906" y="102.51" width="49.74" height="47.58" fill="#75938f" />
        <text
          id="apt_no_8"
          transform="translate(921.05 142.15)"
          fill="#0b253c"
          font-family="NewParisKingSize, NewParis KingSize"
          font-size="44.89"
        >
          <tspan x="0" y="0">
            3
          </tspan>
        </text>
        <rect
          id="floor_button_1"
          x="128.32"
          y="578.95"
          width="737.99"
          height="79.91"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_2"
          x="128.32"
          y="506.04"
          width="738"
          height="73.1"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_3"
          x="128.32"
          y="435.6"
          width="738"
          height="70.44"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_4"
          x="128.32"
          y="362.54"
          width="738"
          height="73.05"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_5"
          x="128.32"
          y="290.78"
          width="737.99"
          height="71.77"
          fill="#7aa9a5"
          opacity=".5"
        />
        <rect
          id="floor_button_6"
          x="128.32"
          y="219.01"
          width="737.99"
          height="71.77"
          fill="#7aa9a5"
          opacity=".5"
        />
        <polyline
          id="floor_button_7"
          points="127.32 149.86 569.32 149.86 570.42 128.04 737.02 110.75 737.02 163.73 866.95 175.11 866.95 219.07 128.32 220 127.32 149.86"
          fill="#7aa9a5"
          opacity=".5"
        />
        <path
          id="floor_button_8"
          d="M588.32,34.86h-164l-142,1h-7v18h-15v-.33c-.13,0-.25,.02-.38,.02h-106.62v.31c-8.33,.07-16.67,.14-25,.21-.33,31.93-.67,63.86-1,95.79h442c.37-7.27,.73-14.55,1.1-21.82l18.41-1.82-.51-91.36Z"
          fill="#7aa9a5"
          opacity=".5"
        />
      </g>
    </svg>
  )
})

export const E1 = forwardRef((props, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" ref={ref} height="100%" viewBox="0 0 690.87 906.08">
      <defs>
        <pattern
          id="_10_lpi_20_"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.11, -0.12, 0, -5.74, 5.38)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_3"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, 3.94)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_5"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, -15.31)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_7"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, 39.81)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_9"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, 57.75)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_11"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, 75.59)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_13"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, 93.55)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_15"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, 111.44)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_17"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.12, -0.12, 0, 0.19, 128.68)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_19"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.11, -0.12, 0, -5.74, 25.22)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_21"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.11, -0.12, 0, -5.74, 42.01)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_23"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.11, -0.12, 0, -5.74, 59.4)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_25"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.11, -0.12, 0, -5.74, 77.51)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_27"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.11, -0.12, 0, -5.74, 95.53)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_29"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.11, -0.12, 0, -5.74, 113.55)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="elevation_e1">
          <polyline
            points="319.04 745.63 319.04 58.98 465.71 100.17 465.71 745.63"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <polygon
            points="318.43 72.54 318.43 0.47 136.31 40.09 136.31 72.54 318.43 72.54"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <rect
            x="338.83"
            y="118.86"
            width="17.99"
            height="56.58"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="356.72"
            y="118.86"
            width="17.99"
            height="56.58"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="387.24"
            y="118.86"
            width="17.99"
            height="56.58"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="405.12"
            y="118.86"
            width="17.99"
            height="56.58"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="338.83"
            y="147.15"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="147.15"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="338.83"
            y="219.32"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="219.32"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="338.83"
            y="292.77"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="292.77"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="338.83"
            y="364.19"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="364.19"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="338.83"
            y="434.12"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="434.12"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="338.83"
            y="505.86"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="505.86"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="338.83"
            y="577.17"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="577.17"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="338.83"
            y="648.06"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="387.24"
            y="648.06"
            width="35.88"
            height="28.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <g>
            <rect
              x="338.83"
              y="191.03"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="356.72"
              y="191.03"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="387.24"
              y="191.03"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="405.12"
              y="191.03"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <rect
            x="550.01"
            y="161.27"
            width="45.64"
            height="86.34"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="161.27"
            width="45.64"
            height="86.34"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="550.01"
            y="264.48"
            width="45.64"
            height="61.33"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="264.48"
            width="45.64"
            height="61.33"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="482.07"
            y1="185.21"
            x2="527.7"
            y2="185.21"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="550.01"
            y1="185.21"
            x2="595.65"
            y2="185.21"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="550.01"
            y="337.37"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="337.37"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="550.01"
            y="405.96"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="405.96"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="550.01"
            y="477.54"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="477.54"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="550.01"
            y="548.7"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="548.7"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="550.01"
            y="619.43"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="619.43"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="550.01"
            y="691.01"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="482.07"
            y="691.01"
            width="45.64"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <g>
            <rect
              x="338.83"
              y="264.48"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="356.72"
              y="264.48"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="387.24"
              y="264.48"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="405.12"
              y="264.48"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <g>
            <rect
              x="338.83"
              y="336.22"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="356.72"
              y="336.22"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="387.24"
              y="336.22"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="405.12"
              y="336.22"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <g>
            <rect
              x="338.83"
              y="405.83"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="356.72"
              y="405.83"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="387.24"
              y="405.83"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="405.12"
              y="405.83"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <g>
            <rect
              x="338.83"
              y="477.57"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="356.72"
              y="477.57"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="387.24"
              y="477.57"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="405.12"
              y="477.57"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <g>
            <rect
              x="338.83"
              y="548.46"
              width="17.99"
              height="57.44"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="356.72"
              y="548.46"
              width="17.99"
              height="57.44"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="387.24"
              y="548.46"
              width="17.99"
              height="57.44"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="405.12"
              y="548.46"
              width="17.99"
              height="57.44"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <g>
            <rect
              x="338.83"
              y="619.77"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="356.72"
              y="619.77"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="387.24"
              y="619.77"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="405.12"
              y="619.77"
              width="17.99"
              height="56.58"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <rect
            x="338.83"
            y="689.37"
            width="27.95"
            height="56.26"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="388.48"
            y="689.37"
            width="34.63"
            height="56.26"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="148.8"
            y="98.07"
            width="25.24"
            height="70.04"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="182.99"
            y="98.07"
            width="25.24"
            height="80.99"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="222.47"
            y="98.07"
            width="25.24"
            height="80.99"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="256.66"
            y="98.07"
            width="25.24"
            height="68.41"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <g>
            <rect
              x="156.63"
              y="193"
              width="50.42"
              height="64.93"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="156.63"
              y="263.92"
              width="50.42"
              height="64.61"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="156.63"
              y="334.84"
              width="50.42"
              height="64.28"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="156.63"
              y="405.75"
              width="50.42"
              height="63.95"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="156.63"
              y="476.67"
              width="50.42"
              height="63.63"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="156.63"
              y="547.58"
              width="50.42"
              height="63.3"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="156.63"
              y="618.5"
              width="50.42"
              height="62.98"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <rect
              x="156.63"
              y="689.41"
              width="50.42"
              height="56.22"
              fill="none"
              stroke="#231f20"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
          </g>
          <rect
            x="223.52"
            y="193"
            width="50.42"
            height="64.93"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="223.52"
            y="263.92"
            width="50.42"
            height="64.61"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="223.52"
            y="334.84"
            width="50.42"
            height="64.28"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="223.52"
            y="405.75"
            width="50.42"
            height="63.95"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="223.52"
            y="476.67"
            width="50.42"
            height="63.63"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="223.52"
            y="547.58"
            width="50.42"
            height="63.3"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="223.52"
            y="618.5"
            width="50.42"
            height="62.98"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="223.52"
            y="689.41"
            width="50.42"
            height="56.22"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <polyline
            points="113.42 745.63 113.42 905.7 317.28 905.7 612.06 905.7 612.06 745.63"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="77.19"
            y1="905.7"
            x2="112.77"
            y2="905.7"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="113.42"
            y1="745.63"
            x2="647.64"
            y2="745.63"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <rect
            x="572.83"
            y="185.21"
            width="22.82"
            height="62.4"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.22"
          />
          <rect
            x="572.83"
            y="264.48"
            width="22.82"
            height="61.33"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="572.83"
            y="337.37"
            width="22.82"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="572.83"
            y="405.96"
            width="22.82"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="572.83"
            y="477.54"
            width="22.82"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="572.83"
            y="548.7"
            width="22.82"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="572.83"
            y="619.43"
            width="22.82"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="572.83"
            y="691.01"
            width="22.82"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="185.21"
            width="15.21"
            height="62.4"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="482.07"
            y="264.48"
            width="15.21"
            height="61.33"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <rect
            x="482.07"
            y="337.37"
            width="15.21"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <rect
            x="482.07"
            y="405.96"
            width="15.21"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <rect
            x="482.07"
            y="477.54"
            width="15.21"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <rect
            x="482.07"
            y="548.7"
            width="15.21"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <rect
            x="482.07"
            y="619.43"
            width="15.21"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <rect
            x="482.07"
            y="691.01"
            width="15.21"
            height="54.62"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <rect
            x="482.07"
            y="718.32"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="646.74"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="576.01"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="504.85"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="433.27"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="364.68"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="298.5"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="482.07"
            y="220.3"
            width="45.64"
            height="27.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
          <rect
            x="465.71"
            y="220.3"
            width="146.35"
            height="31.1"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_)"
          />
          <rect
            x="148.45"
            y="228.49"
            width="133.35"
            height="33.06"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_3)"
          />
          <rect
            x="148.45"
            y="152.57"
            width="133.35"
            height="33.06"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_5)"
          />
          <rect
            x="148.45"
            y="369.88"
            width="133.35"
            height="33.06"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_7)"
          />
          <rect
            x="148.45"
            y="440.62"
            width="133.35"
            height="33.06"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_9)"
          />
          <rect
            x="148.45"
            y="510.94"
            width="133.35"
            height="33.06"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_11)"
          />
          <rect
            x="148.45"
            y="581.76"
            width="133.35"
            height="33.06"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_13)"
          />
          <rect
            x="148.45"
            y="652.29"
            width="133.35"
            height="33.06"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_15)"
          />
          <rect
            x="148.45"
            y="720.25"
            width="133.35"
            height="25.38"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_17)"
          />
          <rect
            x="465.71"
            y="298.5"
            width="146.35"
            height="31.1"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_19)"
          />
          <rect
            x="465.71"
            y="364.68"
            width="146.35"
            height="31.1"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_21)"
          />
          <rect
            x="465.71"
            y="433.27"
            width="146.35"
            height="31.1"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_23)"
          />
          <rect
            x="533.24"
            y="504.64"
            width="78.82"
            height="31.1"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_25)"
          />
          <rect
            x="533.24"
            y="575.69"
            width="78.82"
            height="31.1"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_27)"
          />
          <rect
            x="533.24"
            y="646.74"
            width="78.82"
            height="31.1"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_29)"
          />
          <rect
            x="156.63"
            y="193"
            width="25.21"
            height="64.93"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="193"
            width="26.23"
            height="64.93"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="156.63"
            y="263.76"
            width="25.21"
            height="64.93"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="263.76"
            width="26.23"
            height="64.93"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="156.63"
            y="334.75"
            width="25.21"
            height="64.36"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="334.75"
            width="26.23"
            height="64.36"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="156.63"
            y="405.75"
            width="25.21"
            height="63.95"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="405.75"
            width="26.23"
            height="63.95"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="156.63"
            y="476.5"
            width="25.21"
            height="63.95"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="476.5"
            width="26.23"
            height="63.95"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="156.63"
            y="547.47"
            width="25.21"
            height="63.42"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="547.47"
            width="26.23"
            height="63.42"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="156.63"
            y="618.5"
            width="25.21"
            height="62.98"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="618.5"
            width="26.23"
            height="62.98"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="156.63"
            y="689.37"
            width="25.21"
            height="56.26"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="247.71"
            y="689.37"
            width="26.23"
            height="56.26"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <polyline
            points="612.06 745.63 612.06 142.64 463.58 142.64 463.58 745.63"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
          />
          <polyline
            points="113.42 745.63 113.42 72.54 320.78 72.54 320.78 745.63"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
          />
          <path
            d="M87.91,171v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,171.14H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,171.14h-.19V171"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,170.57V120.85"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,120.66v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,120.47H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,120.47h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,121v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,244v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,244.22H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,244.22h-.19V244"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,243.64V193.93"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,193.74v-.2h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,193.54H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,193.54h.19v.2"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,194.12v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,316.07v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <text />{" "}
          <path
            d="M37.42,316.26h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,315.68V266"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,265.77v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,265.58H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,265.58h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,266.16v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,388.1v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,388.29H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,388.29h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,387.72V338"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,337.81v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,337.62H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,337.62h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,338.19v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,460.14v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,460.33H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,460.33h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,459.75V410"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,409.84v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,409.65H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,409.65h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,410.23v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,532.17v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,532.36H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,532.36h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,531.79V482.07"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,481.88v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,481.69H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,481.69h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,482.26V532"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,603.16v.2h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,603.36H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,603.36h-.19v-.2"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,602.78V553.06"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,552.87v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,552.68H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,552.68h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,553.26V603"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,673.11v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,673.3H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,673.3h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,672.73V623"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,622.82v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,622.63H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,622.63h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,623.2v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,807v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,807.21H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,807.21h-.19V807"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,806.63V756.91"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,756.72v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,756.53H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,756.53h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,757.11v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.91,742v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.33,742.21H37.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.42,742.21h-.19V742"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.23,741.63V691.91"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M37.23,691.72v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M37.81,691.53H87.52"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M87.72,691.53h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M87.91,692.11v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,171v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,171.14H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,171.14h-.19V171"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,170.57V120.85"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,120.66v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,120.47h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,120.47h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,121v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,244v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,244.22H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,244.22h-.19V244"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,243.64V193.93"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,193.74v-.2h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,193.54h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,193.54h.19v.2"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,194.12v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,316.07v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,316.26H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,316.26h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,315.68V266"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,265.77v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,265.58h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,265.58h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,266.16v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,388.1v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,388.29H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,388.29h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,387.72V338"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,337.81v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,337.62h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,337.62h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,338.19v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,460.14v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,460.33H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,460.33h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,459.75V410"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,409.84v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,409.65h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,409.65h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,410.23v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,532.17v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,532.36H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,532.36h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,531.79V482.07"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,481.88v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,481.69h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,481.69h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,482.26V532"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,603.16v.2h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,603.36H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,603.36h-.19v-.2"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,602.78V553.06"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,552.87v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,552.68h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,552.68h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,553.26V603"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,673.11v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,673.3H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,673.3h-.19v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,672.73V623"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,622.82v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,622.63h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,622.63h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,623.2v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,807v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,807.21H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,807.21h-.19V807"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,806.63V756.91"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,756.72v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,756.53h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,756.53h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,757.11v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.91,742v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.33,742.21H638.61"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.42,742.21h-.19V742"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.23,741.63V691.91"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M638.23,691.72v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M638.81,691.53h49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M688.72,691.53h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M688.91,692.11v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
        </g>
        <g id="interactive_floors">
          <rect
            id="floor_circle_1"
            x="37.37"
            y="758.07"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_1"
            transform="translate(54.66 797.7)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            1
          </text>
          <rect
            id="floor_circle_2"
            x="37.37"
            y="693.07"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_2"
            transform="translate(51.16 732.7)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            2
          </text>
          <rect
            id="floor_circle_3"
            x="37.37"
            y="624.16"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_3"
            transform="translate(52.42 663.8)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="floor_circle_4"
            x="37.37"
            y="554.22"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_4"
            transform="translate(51.86 593.85)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            4
          </text>
          <rect
            id="floor_circle_5"
            x="37.37"
            y="483.22"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_5"
            transform="translate(52.01 522.86)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            5
          </text>
          <rect
            id="floor_circle_6"
            x="37.37"
            y="411.19"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_6"
            transform="translate(51.09 450.82)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            6
          </text>
          <rect
            id="floor_circle_7"
            x="37.37"
            y="339.15"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_7"
            transform="translate(52.53 378.79)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            7
          </text>
          <rect
            id="floor_circle_8"
            x="37.37"
            y="267.12"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_8"
            transform="translate(51.48 306.75)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            8
          </text>
          <rect
            id="floor_circle_9"
            x="37.37"
            y="195.08"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_9"
            transform="translate(51.61 234.72)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            9
          </text>
          <rect
            id="floor_circle_10"
            x="37.37"
            y="122"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_10"
            transform="translate(41.44 161.64)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            10
          </text>
          <rect
            id="apt_circle_1"
            x="638.37"
            y="758.07"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_1"
            transform="translate(653.42 797.7)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_2"
            x="638.37"
            y="693.07"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_2"
            transform="translate(653.42 732.7)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_3"
            x="638.37"
            y="624.16"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_3"
            transform="translate(653.42 663.8)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_4"
            x="638.37"
            y="554.22"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_4"
            transform="translate(653.42 593.85)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_5"
            x="638.37"
            y="483.22"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_5"
            transform="translate(653.42 522.86)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_5-2"
            data-name="apt_circle_5"
            x="638.37"
            y="411.19"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_6"
            transform="translate(653.42 450.82)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_6"
            x="638.37"
            y="339.15"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_7"
            transform="translate(653.42 378.79)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_8"
            x="638.37"
            y="267.12"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_8"
            transform="translate(653.42 306.75)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_9"
            x="638.37"
            y="195.08"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_9"
            transform="translate(653.42 234.72)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect id="apt_circle_10" x="638.37" y="122" width="49.74" height="47.58" fill="#75938f" />
          <text
            id="apt_no_10"
            transform="translate(653.42 161.64)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="floor_button_1"
            x="113.42"
            y="761.42"
            width="498.64"
            height="72.23"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_2"
            x="113.42"
            y="689.37"
            width="498.64"
            height="72.23"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_3"
            x="113.42"
            y="619.77"
            width="498.64"
            height="69.6"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_4"
            x="113.42"
            y="547.58"
            width="498.64"
            height="72.19"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_5"
            x="113.42"
            y="476.67"
            width="498.64"
            height="70.92"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_6"
            x="113.42"
            y="405.75"
            width="498.64"
            height="70.92"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_7"
            x="113.42"
            y="334.84"
            width="498.64"
            height="70.92"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_8"
            x="113.42"
            y="263.92"
            width="498.64"
            height="70.92"
            fill="#7aa9a5"
          />
          <polygon
            id="floor_button_9"
            points="612.06 142.63 612.06 263.92 113.42 263.92 113.42 191.03 465.65 191.03 465.65 142.63 612.06 142.63"
            fill="#7aa9a5"
          />
          <polygon
            id="floor_button_10"
            points="465.71 191.03 113.42 191.03 113.42 73.01 319.04 73.01 319.04 58.98 465.71 100.17 465.71 191.03"
            fill="#7aa9a5"
          />
          <polygon
            id="floor_button_t"
            points="136.31 40.09 318.43 0.47 318.43 72.54 136.31 72.54 136.31 40.09"
            fill="#7aa9a5"
          />
          <text />
        </g>
      </g>
    </svg>
  )
})
export const K1 = forwardRef((props, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" ref={ref} width="100%" viewBox="0 0 655.6 298.06">
      <defs>
        <pattern
          id="_10_lpi_20_"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.19, -0.23, 0, -116.61, 67.9)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_3"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.19, -0.23, 0, -117.04, 114.19)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_5"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.19, -0.23, 0, -122.75, 143.4)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_7"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0, -0.19, -0.23, 0, -117.04, 92.31)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_9"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0.12, 0, 0, -0.12, -147.43, -47.38)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_11"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0.12, 0, 0, -0.12, -223.14, -47.38)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
        <pattern
          id="_10_lpi_20_13"
          data-name="10 lpi 20%"
          width="72"
          height="72"
          patternTransform="matrix(0.12, 0, 0, -0.12, -181.59, -47.38)"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 72 72"
        >
          <rect width="72" height="72" fill="none" />
          <g>
            <line
              x1="71.75"
              y1="68.4"
              x2="144.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="54"
              x2="144.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="39.6"
              x2="144.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="25.2"
              x2="144.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="10.8"
              x2="144.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="61.2"
              x2="144.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="46.8"
              x2="144.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="32.4"
              x2="144.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="18"
              x2="144.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="71.75"
              y1="3.6"
              x2="144.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-0.25"
              y1="68.4"
              x2="72.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="54"
              x2="72.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="39.6"
              x2="72.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="25.2"
              x2="72.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="10.8"
              x2="72.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="61.2"
              x2="72.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="46.8"
              x2="72.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="32.4"
              x2="72.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="18"
              x2="72.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-0.25"
              y1="3.6"
              x2="72.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
          <g>
            <line
              x1="-72.25"
              y1="68.4"
              x2="0.25"
              y2="68.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="54"
              x2="0.25"
              y2="54"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="39.6"
              x2="0.25"
              y2="39.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="25.2"
              x2="0.25"
              y2="25.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="10.8"
              x2="0.25"
              y2="10.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="61.2"
              x2="0.25"
              y2="61.2"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="46.8"
              x2="0.25"
              y2="46.8"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="32.4"
              x2="0.25"
              y2="32.4"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="18"
              x2="0.25"
              y2="18"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
            <line
              x1="-72.25"
              y1="3.6"
              x2="0.25"
              y2="3.6"
              fill="none"
              stroke="#231f20"
              strokeWidth="1.44"
            />
          </g>
        </pattern>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="elevation_k1">
          <path
            d="M52.64,135v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M52.06,135.21H2.35"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M2.16,135.21H2V135"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M2,134.64V84.92"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M2,84.73v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M2.54,84.54H52.26"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M52.45,84.54h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M52.64,85.11v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M52.64,204.93v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M52.06,205.12H2.35"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M2.16,205.12H2v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M2,204.54V154.82"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M2,154.63v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M2.54,154.44H52.26"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M52.45,154.44h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M52.64,155v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M653.64,135v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M653.06,135.21H603.35"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M603.16,135.21H603V135"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M603,134.64V84.92"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M603,84.73v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M603.54,84.54h49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M653.45,84.54h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M653.64,85.11v49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M653.64,204.93v.19h-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M653.06,205.12H603.35"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M603.16,205.12H603v-.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M603,204.54V154.82"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M603,154.63v-.19h.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M603.54,154.44h49.72"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <path
            d="M653.45,154.44h.19v.19"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
          />
          <path
            d="M653.64,155v49.71"
            fill="none"
            stroke="#0b253c"
            strokeMiterlimit="10"
            strokeWidth="3.93"
            strokeDasharray="0.39 0.39"
          />
          <line
            x1="128.6"
            y1="297.5"
            x2="520.53"
            y2="297.5"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="491.17"
            y1="155.64"
            x2="513.96"
            y2="155.64"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="135.17"
            y1="155.64"
            x2="158.24"
            y2="155.64"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="491.17"
            y1="234.4"
            x2="513.96"
            y2="244.25"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="135.17"
            y1="244.25"
            x2="158.24"
            y2="234.4"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="491.17"
            y1="83.79"
            x2="513.96"
            y2="83.79"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="135.17"
            y1="83.79"
            x2="158.24"
            y2="83.79"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <polyline
            points="158.24 297.5 158.24 43.67 491.17 43.67 491.17 297.5"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
          />
          <polygon
            points="226.23 139.31 174.78 139.31 174.78 67.25 174.78 53.42 226.23 53.42 226.23 139.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="236.8"
            y="53.42"
            width="51.45"
            height="85.9"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="298.81"
            y="53.42"
            width="51.45"
            height="85.9"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="360.83"
            y="53.42"
            width="51.45"
            height="85.9"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="422.85"
            y="53.42"
            width="51.45"
            height="85.9"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="174.78"
            y="147.93"
            width="51.45"
            height="63.23"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="174.78"
            y="224.06"
            width="51.45"
            height="65.96"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="237.11"
            y="224.06"
            width="176.31"
            height="73.21"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="236.8"
            y="147.93"
            width="51.45"
            height="63.24"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="298.81"
            y="147.93"
            width="51.45"
            height="63.24"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="360.83"
            y="147.93"
            width="51.45"
            height="63.24"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <rect
            x="422.85"
            y="147.93"
            width="51.45"
            height="63.24"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="201.53"
            y1="237.67"
            x2="201.53"
            y2="290.03"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="174.78"
            y1="237.68"
            x2="226.46"
            y2="237.68"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="423.41"
            y="224.06"
            width="51.45"
            height="65.96"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="450.15"
            y1="237.67"
            x2="450.15"
            y2="290.03"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="423.41"
            y1="237.68"
            x2="475.08"
            y2="237.68"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="174.78"
            y1="67.24"
            x2="225.32"
            y2="67.24"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <line
            x1="236.21"
            y1="67.25"
            x2="288.25"
            y2="67.25"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <line
            x1="299.45"
            y1="67.25"
            x2="350.44"
            y2="67.25"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="360.61"
            y1="67.25"
            x2="411.83"
            y2="67.25"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <line
            x1="422.85"
            y1="67.25"
            x2="474.85"
            y2="67.25"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.18"
          />
          <line
            x1="237.11"
            y1="237.67"
            x2="413.42"
            y2="237.67"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="331.39"
            y1="237.68"
            x2="331.39"
            y2="297.84"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <line
            x1="368.09"
            y1="237.68"
            x2="368.09"
            y2="297.28"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <rect
            x="260.44"
            y="0.38"
            width="214.41"
            height="43.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <line
            x1="260.47"
            y1="9.29"
            x2="475.08"
            y2="9.29"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.75"
          />
          <rect
            x="260.47"
            y="0.38"
            width="214.38"
            height="43.31"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.44"
            fill="url(#_10_lpi_20_)"
          />
          <rect
            x="298.81"
            y="147.93"
            width="51.33"
            height="63.24"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.44"
            fill="url(#_10_lpi_20_3)"
          />
          <rect
            x="280.06"
            y="243.85"
            width="51.33"
            height="53.99"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.44"
            fill="url(#_10_lpi_20_5)"
          />
          <rect
            x="298.81"
            y="60.68"
            width="51.33"
            height="78.63"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.44"
            fill="url(#_10_lpi_20_7)"
          />
          <polygon
            points="474.85 237.68 474.85 224.06 423.4 224.06 423.4 237.68 474.85 237.68"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_9)"
          />
          <polygon
            points="226.23 237.68 226.23 224.06 174.78 224.06 174.78 237.68 226.23 237.68"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
            fill="url(#_10_lpi_20_11)"
          />
          <polygon
            points="413.42 237.68 413.42 224.06 237.11 224.06 237.11 237.68 413.42 237.68"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.26"
            fill="url(#_10_lpi_20_13)"
          />
          <polygon
            points="203.34 139.31 181.35 139.31 181.35 92.73 181.35 83.79 203.34 83.79 203.34 139.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <polygon
            points="203.34 211.16 181.35 211.16 181.35 164.58 181.35 155.64 203.34 155.64 203.34 211.16"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <polygon
            points="368.09 297.84 331.39 297.84 331.39 252.55 331.39 243.85 368.09 243.85 368.09 297.84"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <polygon
            points="468.28 139.31 446.3 139.31 446.3 92.73 446.3 83.79 468.28 83.79 468.28 139.31"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <polygon
            points="468.28 211.16 446.3 211.16 446.3 164.58 446.3 155.64 468.28 155.64 468.28 211.16"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.36"
          />
          <polygon
            points="368.09 297.84 350.26 297.84 350.26 252.55 350.26 243.85 368.09 243.85 368.09 297.84"
            fill="none"
            stroke="#231f20"
            strokeMiterlimit="10"
            strokeWidth="0.25"
          />
        </g>
        <g id="interactive_floors">
          <rect
            id="floor_circle_1"
            x="2.11"
            y="155.98"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_1"
            transform="translate(19.4 195.61)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            1
          </text>
          <rect
            id="floor_circle_2"
            x="2.11"
            y="86.07"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="floor_no_2"
            transform="translate(15.9 125.71)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            2
          </text>
          <rect
            id="apt_circle_1"
            x="603.11"
            y="155.98"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_1"
            transform="translate(618.15 195.61)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="apt_circle_2"
            x="603.11"
            y="86.07"
            width="49.74"
            height="47.58"
            fill="#75938f"
          />
          <text
            id="apt_no_2"
            transform="translate(618.15 125.71)"
            fontSize="44.89"
            fill="#0b253c"
            fontFamily="NewParisKingSize, NewParis KingSize"
          >
            3
          </text>
          <rect
            id="floor_button_1"
            x="158.24"
            y="147.93"
            width="332.93"
            height="75.94"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_2"
            x="158.24"
            y="43.67"
            width="332.93"
            height="104.26"
            fill="#7aa9a5"
          />
          <rect
            id="floor_button_t"
            x="260.44"
            y="0.38"
            width="214.64"
            height="43.29"
            fill="#7aa9a5"
          />
        </g>
      </g>
    </svg>
  )
})
